module.exports = __webpack_public_path__ + "static/media/emoji_1.0b1e735e.svg";